import { render, staticRenderFns } from "./license-oss-upload.vue?vue&type=template&id=38068107&"
import script from "./license-oss-upload.vue?vue&type=script&lang=js&"
export * from "./license-oss-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports